import { API } from '@/lib/api';
import { API_SERVICES } from '../constants';
import type { Organizations } from './organizations-interface';

export async function getOrganizations(): Promise<Organizations[]> {
  try {
    const res = await API.get(API_SERVICES.BASE_API, `/organizations`, {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    });

    return res.data;
  } catch (error) {
    console.error('Failed to fetch organizations:', error);
    throw error;
  }
}
